import { create } from "zustand"

// Which quotation's on-demand annotated result PDF is being generated right now (#1401), or null.
//
// Module-level rather than per-hook state, for the same reason resultCsv.store.ts is: the control
// exists on two surfaces at once — the quotations table row menu and the editor's burger menu, which
// sits in the Apryse shadow DOM behind the drawer. Per-instance state would let those two start
// concurrent generations, and would lose the busy flag whenever Apryse re-roots the header.
//
// A SEPARATE store from resultCsv.store.ts on purpose: the CSV and PDF builds are two independent
// backend jobs with no reason to block each other, so "one PDF generation at a time" and "one CSV
// generation at a time" are independent constraints, each still global across both surfaces.
type ResultPdfStore = {
	busyQuotationId: number | null
	setBusyQuotationId: (quotationId: number | null) => void
}

export const useResultPdfStore = create<ResultPdfStore>((set) => ({
	busyQuotationId: null,
	setBusyQuotationId: (quotationId) => set({ busyQuotationId: quotationId }),
}))

// Selector hooks, so a component subscribes only to the slice it renders — the orchestrator takes
// the download action WITHOUT either of these and therefore never re-renders on a PDF download.
export const useResultPdfBusyQuotationId = () => useResultPdfStore((state) => state.busyQuotationId)

export const useIsResultPdfPending = () => useResultPdfStore((state) => state.busyQuotationId !== null)
